module.exports = __webpack_public_path__ + "static/media/crater-lake.e4d28340.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Header/images/backgrounds/crater-lake.png
 ** module id = 181
 ** module chunks = 0
 **/